import { render, staticRenderFns } from "./DiagnosisCodeWizard.vue?vue&type=template&id=47b85ad5&"
import script from "./DiagnosisCodeWizard.vue?vue&type=script&lang=js&"
export * from "./DiagnosisCodeWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports